<template>
  <div class="links-container">
    <!--<a :id="`${prefix}-dl-brochure`" class="link" @click.prevent="showOrderForm" href="#">
      Order Brochure
    </a>-->
    <router-link
      :id="`${prefix}-get-newsletter`"
      class="link"
      target="_blank"
      to="/subscribe"
    >Get our Newsletter
    </router-link>
    <router-link
      :id="`${prefix}-view-vacation-guide`"
      class="link"
      target="_blank"
      to="/online-vacation-guide"
    >Explore the Guide
    </router-link>
    <router-link
      :id="`${prefix}-travel-guides`"
      class="link"
      target="_blank"
      to="/travel-guides"
    >Order the Guide
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'FlexLinks',
  props: {
    prefix: {
      type: String,
      required: true,
    },
  },
  methods: {
    showOrderForm() {
      this.$store.dispatch('guideModal/showModal');
    },
  },
};
</script>

<style scoped>
  .links-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 3rem;
  }

  .link {
    background-color: #173945;
    border-radius: 8px;
    border: solid 1px #4e97b2;
    color: #fff;
    font-family: "klinicslabbold";
    font-size: 19px;
    min-height: 40px;
    text-decoration: none;
    padding: 10px 25px;
    margin: 0 35px;
  }

  @media (max-width: 768px) {
    .links-container {
      flex-direction: column;
      align-items: center;
    }

    .link {
        margin: 0 35px 25px 35px;
    }
  }
  </style>
